import { http } from '@noor/api';
import {
  orderNoteSchema,
  type OrderNote,
  type CreateOrderNoteInput,
} from '../model/schema';

/**
 * Order-note endpoints. The list response nests as `data.data` in cpanel; we
 * tolerate both `{data: [...]}` and a bare array.
 */
export const orderNoteApi = {
  async list(orderId: string | number): Promise<OrderNote[]> {
    const raw = await http.get<unknown>('admin/notes', {
      query: { order_id: String(orderId) },
    });
    return orderNoteSchema.array().parse(extractList(raw));
  },

  async create(input: CreateOrderNoteInput): Promise<unknown> {
    return await http.post('admin/notes', input);
  },
};

function extractList(raw: unknown): unknown[] {
  if (Array.isArray(raw)) return raw;
  if (raw && typeof raw === 'object' && 'data' in raw) {
    const inner = raw.data;
    if (Array.isArray(inner)) return inner;
    if (inner && typeof inner === 'object' && 'data' in inner) {
      const nested = inner.data;
      if (Array.isArray(nested)) return nested;
    }
  }
  return [];
}
